<fa-icon [icon]="icon" class="mr-2"></fa-icon>
<ng-content></ng-content>
